export default {
  presets: {
    light: {
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundElement: '#ECF0F1',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      textPrimary: '#262824',
      textInverted: '#FFFFFF',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
      textPrimary: '#e4e4e7',
      textInverted: '#1a1a2e',
      success: '#3D9209',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
    },
  },
}
